import type { FC } from 'react';
import { lazy } from 'react';
import { useParams } from 'react-router-dom';
import { useNetworkPointByUuid } from 'src/apis/monolith/use-network-point-by-uuid';
import { useOptionalOrganisationDetails } from 'src/apis/organisation-service/use-organisation-details';
import { useOptionalOrganisationService } from 'src/apis/organisation-service/use-organisation-service';
import { useBulletinBoardNotice } from 'src/apis/secondary-market-service/use-bulletin-board-notice';
import {
  useSecondaryMarketService,
  type SecondaryMarketServiceRequest,
} from 'src/apis/secondary-market-service/use-secondary-market-service';
import { PageSpinner } from 'src/components/spinner-container';

const Page = lazy(() => import('./page'));

export const BulletinBoardNoticeDetails: FC = () => {
  const secondaryMarketService = useSecondaryMarketService();

  if (!secondaryMarketService.response) return <PageSpinner />;

  return <LoadData secondaryMarketService={secondaryMarketService} />;
};

const LoadData: FC<{
  secondaryMarketService: SecondaryMarketServiceRequest;
}> = ({ secondaryMarketService }) => {
  const { bulletinBoardNoticeId } = useParams<{
    bulletinBoardNoticeId: string;
  }>();

  const notice = useBulletinBoardNotice({
    secondaryMarketService,
    bulletinBoardNoticeId,
  });

  const nwpUuid =
    notice.response?.data?.unbundledNetworkPoint?.networkPointId ??
    notice.response?.data?.bundledNetworkPoint?.bundleId;

  const networkPointByUuid = useNetworkPointByUuid(nwpUuid);

  const organisationService = useOptionalOrganisationService();
  const myOrgDetails = useOptionalOrganisationDetails({ organisationService });

  if (
    !secondaryMarketService.response ||
    !notice.response ||
    !networkPointByUuid.response
  )
    return <PageSpinner />;

  return (
    <Page
      notice={notice}
      myOrganisationDetails={myOrgDetails?.response?.data}
      networkPoint={networkPointByUuid.response.data}
    />
  );
};
